<p-toast></p-toast>

<div class="int-page">
  <div class="int-header">
    <h1 class="int-title">Integrations</h1>
    <div class="switch-tabs">
      <button
        type="button"
        [class.active]="activeIntegration === 'kisha'"
        (click)="setIntegration('kisha')">
        Kisha
      </button>
      <button
        type="button"
        [class.active]="activeIntegration === 'ewmr'"
        (click)="setIntegration('ewmr')">
        EWMR/NCR
      </button>
      <button
        type="button"
        [class.active]="activeIntegration === 'commonTags'"
        (click)="setIntegration('commonTags')">
        Common Tags
      </button>
      <button
        type="button"
        [class.active]="activeIntegration === 'dashboard'"
        (click)="setIntegration('dashboard')">
        Dashboard
      </button>
    </div>
  </div>

  <div class="int-grid-wrap">
    <div class="int-panel-hdr">
      <p class="int-panel-desc">Map integration source fields to Navigator fields and assign them to templates.</p>
      <div class="int-panel-actions">
        @if (activeIntegration === 'dashboard') {
          <p-select
            inputId="dashboardTemplateCategorySelect"
            [options]="dashboardTemplateCategoryOptions"
            optionLabel="label"
            optionValue="value"
            [(ngModel)]="dashboardTemplateCategory"
            (onChange)="onDashboardTemplateCategoryChanged()"
            appendTo="body"
            styleClass="int-category-select">
          </p-select>
        }

        <p-select
          inputId="integrationTemplateSelect"
          [options]="currentTemplates"
          optionLabel="templateName"
          optionValue="templateId"
          [(ngModel)]="selectedTemplateId"
          (onChange)="onTemplateChanged()"
          [loading]="isLoadingTemplates"
          [filter]="true"
          filterBy="templateName"
          [scrollHeight]="'300px'"
          appendTo="body"
          placeholder="Select Template"
          styleClass="int-template-select">
        </p-select>

        <button class="int-btn-save" type="button" (click)="saveRows()" [disabled]="saving || isLoadingMappings || !selectedTemplateId">
          <i class="ri-save-line"></i>
          Save
        </button>
        <button class="int-btn-clone" type="button" (click)="openCloneDialog()" [disabled]="saving || cloning || isLoadingMappings || !selectedTemplateId">
          <i class="ri-file-copy-line"></i>
          Clone
        </button>
      </div>
    </div>

    <div class="int-grid-header" [class.int-grid-no-source]="!showSourceColumn">
      <div class="int-header-checkbox-cell">
        <input
          type="checkbox"
          class="int-checkbox"
          [checked]="isAllMappedSelected()"
          [indeterminate]="isSomeMappedSelected()"
          [disabled]="!selectedTemplateId || isLoadingMappings || saving"
          (change)="toggleSelectAllMapped($any($event.target).checked)" />
      </div>
      @if (showSourceColumn) {
        <div>{{ sourceLabel }}</div>
      }
      <div>{{ idLabel }}</div>
      <div>Data Type</div>
      <div>Comments</div>
      <div>Action</div>
    </div>

    <div class="int-grid-body">
      @for (row of currentRows; track trackByRow($index, row); let i = $index) {
        <div class="int-grid-row" [class.int-grid-no-source]="!showSourceColumn">
          <div>
            <div class="int-checkbox-wrap">
              <input
                type="checkbox"
                class="int-checkbox"
                [checked]="isTemplateMapped(row)"
                [disabled]="!selectedTemplateId || isLoadingMappings || saving || !isRowValid(row)"
                (change)="onTemplateMappedChange(row, $any($event.target).checked)" />
            </div>
          </div>
          @if (showSourceColumn) {
            <div>
              <input
                type="text"
                class="int-input"
                [(ngModel)]="row.sourceId"
                (ngModelChange)="onRowChanged(i)"
                [placeholder]="'Enter ' + sourceLabel" />
            </div>
          }
          <div>
            <input
              type="text"
              class="int-input"
              [(ngModel)]="row.kanseiId"
              (ngModelChange)="onRowChanged(i)"
              [placeholder]="activeIntegration === 'commonTags' || activeIntegration === 'dashboard' ? 'Enter Tag Id' : 'Enter Navigator Id'" />
          </div>
          <div>
            <input
              type="text"
              class="int-input"
              [(ngModel)]="row.dataType"
              (ngModelChange)="onRowChanged(i)"
              (blur)="onDataTypeBlur(row)"
              placeholder="Enter Data Type" />
          </div>
          <div>
            <input
              type="text"
              class="int-input"
              [(ngModel)]="row.comments"
              (ngModelChange)="onRowChanged(i)"
              placeholder="Enter Comments" />
          </div>
          <div>
            <div class="int-action-cell">
              <button
                type="button"
                class="int-icon-btn int-icon-btn--delete"
                (click)="deleteRow(i)"
                [disabled]="saving || isLoadingMappings"
                title="Delete row">
                <i class="ri-delete-bin-line"></i>
              </button>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>

<p-dialog
  header="Clone Mapping to Templates"
  [(visible)]="showCloneDialog"
  [modal]="true"
  [style]="{ width: '40rem' }"
  [contentStyle]="{ overflow: 'auto' }">
  <div class="int-clone-body">
    <label for="cloneTargetTemplates" class="int-clone-label">Target Templates</label>
    <p-multiSelect
      inputId="cloneTargetTemplates"
      [options]="cloneTargetTemplateOptions"
      optionLabel="templateName"
      optionValue="templateId"
      [(ngModel)]="cloneTargetTemplateIds"
      [filter]="true"
      filterBy="templateName"
      [showToggleAll]="true"
      [scrollHeight]="'300px'"
      appendTo="body"
      placeholder="Select templates"
      styleClass="w-full">
    </p-multiSelect>
  </div>
  <ng-template pTemplate="footer">
    <div class="modal-footer">
      <button type="button" class="modal-btn-cancel" (click)="showCloneDialog = false" [disabled]="cloning">Cancel</button>
      <button type="button" class="modal-btn-primary" (click)="cloneSelections()" [disabled]="cloning">
        @if (cloning) {
          <i class="ri-loader-4-line ctrl-spin"></i>
        }
        Save
      </button>
    </div>
  </ng-template>
</p-dialog>
